export class BankIdQrCodeResponse {
    constructor(response) {
        if (!response) {
            throw new Error("Response can not be falsy");
        }
        if (!response.orderRef) {
            throw new Error("Response is missing an orderRef");
        }
        if (!response.qrCodeAsBase64) {
            throw new Error("Response is missing a QR code");
        }
        this.orderRef = response.orderRef;
        this.qrCodeAsBase64 = response.qrCodeAsBase64;
    }
    getOrderRef() {
        return this.orderRef;
    }
    getQrCode() {
        return this.qrCodeAsBase64;
    }
}
